'use client';

import { globalGetZoneScript } from './getZone';

import { getFeatureFlags } from '@/shared/config/features';
import { getTrackingScript } from '@/shared/utils/getTrackingScript';

const isProdEnv = process.env.NEXT_PUBLIC_DEPLOY_ENV === 'prod';

// Глобальная функция определения зоны - доступна для всех интеграционных скриптов
const globalGetZone = globalGetZoneScript;

// Собираем конфиги для всех зон
const configs = {
  kz: getTrackingScript('kz'),
  ru: getTrackingScript('ru'),
  com: getTrackingScript('com'),
  am: getTrackingScript('am'),
  ge: getTrackingScript('ge'),
  tg: getTrackingScript('tg'),
};

// Инлайновый скрипт выполняется синхронно во время парсинга HTML —
// до гидрации React, поэтому аналитика стартует максимально рано
const bootstrapScript = `(function(){
  var zone = window.__getZone ? window.__getZone() : window.location.hostname.split('.').pop();
  var configs = ${JSON.stringify(configs)};
  var code = configs[zone];
  if (!code || !code.scriptHtml) return;
  var s = document.createElement('script');
  s.innerHTML = code.scriptHtml;
  document.head.appendChild(s);
})();`;

const bootstrapNoscript = `(function(){
  var zone = window.__getZone ? window.__getZone() : window.location.hostname.split('.').pop();
  var configs = ${JSON.stringify(configs)};
  var code = configs[zone];
  if (!code || !code.noscriptHtml) return;
  var ns = document.createElement('noscript');
  ns.innerHTML = code.noscriptHtml;
  document.body.appendChild(ns);
})();`;

/** Вставляется в <head> */
export const TrackingScriptsHead = () => {
  if (!isProdEnv) {
    return (
      <>
        {/* Глобальная функция getZone для переиспользования в интеграциях */}
        <script dangerouslySetInnerHTML={{ __html: globalGetZone }} />
      </>
    );
  }

  return (
    <>
      {/* Глобальная функция getZone для переиспользования в интеграциях */}
      <script dangerouslySetInnerHTML={{ __html: globalGetZone }} />
      <script dangerouslySetInnerHTML={{ __html: bootstrapScript }} />
    </>
  );
};

// Mango Office скрипт для .ru домена
// Использует глобальную функцию window.__getZone
const MANGO_SCRIPT = `
    (function() {
      var zone = window.__getZone ? window.__getZone() : undefined;
      if (zone !== 'ru') return;
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://widgets.mango-office.ru/site/37995';
      document.body.appendChild(s);
    })();
  `;

/** Вставляется в <body> */
export const TrackingScriptsNoscript = () => {
  const features = getFeatureFlags();

  // Основные трекинг-скрипты только на проде
  const mainScript = isProdEnv ? (
    <script dangerouslySetInnerHTML={{ __html: bootstrapNoscript }} />
  ) : null;

  return (
    <>
      {mainScript}
      {features.enableMaskedPhone && (
        <script dangerouslySetInnerHTML={{ __html: MANGO_SCRIPT }} />
      )}
    </>
  );
};
